var url = require('url');
var $ = require('js/sw-jquery/sw-jquery');
var jQuery = $;
var sw = require('js/lib/sw');

function removeModel() {
  var listId = jQuery('#listId').val();
  var hashId =  $(this).attr('hashid');
  var csrfId = $(this).attr('data-sw-csrf');
  jQuery.ajax({
    type: "POST",
    url: '/lists/json/remove-item',
    data: {
           listId: listId,
           entityTypeId: 20,
           entityId: hashId,
           _csrf: csrfId
          },
    dataType: 'json',
    success: function() {
      window.location.reload(true);
    }
  });
}

function addModelHover() {
  jQuery(this).children('.wishlist-model-hover').show();
}

function removeModelHover() {
  jQuery(this).children('.wishlist-model-hover').hide();
}

function selectList() {
  var listName = jQuery(this).children("input[name='listName']").val();

  window.location.href = 'http://'+window.location.hostname+'/lists?listName='+listName;
}

function populateShareModal() {
  jQuery('.wishlist-title').html(jQuery('#wishlist-name').text());  

  var isprivate = jQuery('#is_private').attr('checked');
  if(isprivate) {
    jQuery('.copy-link a').show();
    jQuery('#wishlist-container[name=share-container] p').html("Since this list is private, only those who have the special link below will be able to view your list. To share your list, just copy and paste the link below or share by email.");
  } else {
    jQuery('.copy-link a').hide();
    jQuery('#wishlist-container[name=share-container] p').html("To share your list, just copy and paste the link below or share by email.");
  }

  // var shortUrl = jQuery('.wishlist-summary-selected').children('input[name="shortUrl"]').val();
  // jQuery('#short-url').val(shortUrl);
}

function sendLink() {
  var subject = encodeURIComponent($('#share-link-subject').val());
  var body = encodeURIComponent($('#share-link-message').val());
  window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
}


jQuery().ready(function($) {
  jQuery('.wishlist-summary').click(selectList);

  jQuery('#share-link a').click(function(){
    if( jQuery('.share').hasClass('embed-disabled')){
      return;
    }
    sw.notifications.dialog('#modal-share', 'Share This List', true, '648px', '');
  });

  jQuery('#send-link a').click(sendLink);
  jQuery('.product-box').hover(addModelHover, removeModelHover);
  jQuery('[data-remove-from-list] a').click(removeModel);

  populateShareModal();

  if(jQuery('#hide_iconic').val()) {
    jQuery('.iconic').css('display','none');
  }

  $('#searchResultsSortOptions').on('change', function() {
    var parsedUrl = url.parse(document.location.href, true);
    parsedUrl.query.sort = $(this).val();
    parsedUrl.search = void 0;
    document.location.href = url.format(parsedUrl);
  });

});
